/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import classNames from "classnames";
import styles from './LeftListItem.module.scss';
import {JobConfigsInterface, JobHistoryInterface} from "../SystemBatchRun.interface";
import {convertCronToKorean, formatKorDate} from "../../../util/date";
import dayjs from "dayjs";

interface LeftListItemProps {
	data: JobConfigsInterface;
	selected?: boolean;
	onClick: (data: JobConfigsInterface) => void;
}

const LeftListItem = ({data, selected, onClick}: LeftListItemProps) => {
	const getColor = (text: string) => {
		if (text === 'active') return '#007BFF';
		else if (text === 'completed') return '#28A745';
		else if (text === 'failed') return '#DC3545';
		return 'black'
	};

	return (
		<div
			className={classNames(styles.wrap, {[styles.selected]: selected})}
			onClick={() => onClick(data)}
		>
			<div className={styles.leftWrap}>
				<div style={{ fontWeight: 'bold' }}>{data.description}</div>
				<div>{data.queueName}</div>
				<div>{`${convertCronToKorean(data.schedule)} (${data.schedule})`}</div>
			</div>

			{data.latestJob && (
				<div className={styles.rightWrap}>
					<div>
						<span style={{color: getColor(data.latestJob.status), marginRight: '4px'}}>●</span>
						{formatKorDate(data.latestJob?.createDate.toLocaleString())}
					</div>
					<div>{dayjs(data.latestJob?.createDate?.toLocaleString()).format('HH:mm')}</div>
				</div>
			)}

		</div>
	);
};

export default LeftListItem;
